import React from 'react';
import Navbar from "./components/Navbar";
import Hero from "./components/Home";
import About from "./components/About";
import CustomBranding from "./components/CustomBranding";
import WhyChoose from "./components/WhyChoose";
import OurProducts from "./components/ProductOfferings";
import Testimonials from "./components/Testimonials";
import ContactUs from "./components/ContactUs";
// import Footer from "./components/Footer";

function App() {
  return (
    <div>
      {/* <Header /> */}
      <Navbar />
      <section id="hero"><Hero /></section>
      <section id="our-products"><OurProducts /></section>
      <section id="custom-branding"><CustomBranding /></section>
      <section id="about"><About /></section>     
      <section id="why-choose"><WhyChoose /></section>
      <section id="testimonials"><Testimonials /></section>
      <section id="contact-us"><ContactUs /></section>
      
      {/* <Footer /> */}
    </div>
  );
}

export default App;